import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const isPasswordValid: ValidatorFn = (control: UntypedFormGroup): {[key: string]: any} | null => {
  const hasUppercase = new RegExp(/[A-Z]/);
  const hasLowercase = new RegExp(/[a-z]/);
  const hasNumber = new RegExp(/[0-9]/);
  const hasSpecial = new RegExp(/[\s!\"#$%&'()*+,-.\/:;<=>?@[\]^_`{|}~]/);

  const rulesArray = [hasUppercase, hasLowercase, hasNumber, hasSpecial];

  const length = new RegExp(/^[a-zA-Z0-9@$!%*#?&]{8,32}$/);
  const triple = new RegExp(/(.)\1{2,}/);

  if (control.value !== null && control.value.length) {
    let i = 0;
    if (!length.test(control.value)) {
 return { passwordLengthError: true };
}
    if (triple.test(control.value)) {
 return { passwordDuplicateError: true };
}
    for (const rule of rulesArray) {
      if (rule.test(control.value)) {
 i++;
}
    }
    if (i < 3) {
 return { passwordNotValid: true };
}
  }
  return null;
};
